"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.signUpDoctorSubstituteApiResponseSchema = void 0;
const zod_1 = require("zod");
exports.signUpDoctorSubstituteApiResponseSchema = zod_1.z.object({
    success: zod_1.z.boolean(),
});
